export type ProductMetadata = {
  brand: string
  image: string
  name: string
  description: string
  price?: number
  sku?: number
  availability: string
  review: {
    ratingValue?: number
    reviewCount?: number
    comments: Array<{
      author: string
      ratingValue: number
      datePublished: string
      reviewBody: string
    }>
  }
}

export const createProductStructuredData = (
  productMetadata: ProductMetadata
) => ({
  '@context': 'https://schema.org/',
  '@type': 'Product',
  availability: productMetadata.availability,
  brand: {
    '@type': 'Brand',
    name: productMetadata.brand,
  },
  image: productMetadata.image,
  name: productMetadata.name,
  sku: productMetadata.sku?.toString(),
  description: productMetadata.description,
  offers: {
    '@type': 'Offer',
    priceCurrency: 'BRL',
    price: productMetadata.price?.toString(),
  },
  review: productMetadata.review.comments.length
    ? productMetadata.review.comments?.map((comment) => ({
        '@type': 'Review',
        datePublished: comment.datePublished,
        reviewBody: comment.reviewBody,
        reviewRating: {
          '@type': 'Rating',
          ratingValue: comment.ratingValue,
        },
        author: {
          '@type': 'Person',
          name: comment.author,
        },
      }))
    : undefined,
  aggregateRating:
    !!productMetadata.review.ratingValue && !!productMetadata.review.reviewCount
      ? {
          '@type': 'AggregateRating',
          ratingValue: productMetadata.review.ratingValue.toString(),
          ratingCount: productMetadata.review.reviewCount.toString(),
        }
      : undefined,
})

export const createDefaultStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  url: 'https://www.gazin.com.br/',
  sameAs: [
    'https://www.facebook.com/gazin',
    'https://www.instagram.com/gazin/',
    'https://www.youtube.com/user/gazinoficial',
    'https://www.linkedin.com/company/gazin/',
  ],
  logo: 'https://ecommerce30032022.blob.core.windows.net/e-commerce/midias/imagens/2024/05/2c05fbca-55c3-419c-9d01-f5c07cc7da38.png',
  name: 'Gazin | Sua Loja de Telefonia, Eletrodomésticos e Muito Mais',
  description:
    'Encontre na Gazin uma ampla seleção de telefonia, eletrodomésticos e muito mais. Produtos de qualidade com os melhores preços do mercado. Acesse já!',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rodovia PR 082 S/N KM 01',
    addressLocality: 'Douradina',
    addressRegion: 'PR',
    addressCountry: 'BR',
    postalCode: '87485-000',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'sac@gazin.com.br',
    telephone: '0800-644-9292',
  },
})
